export * from './absorb-by.pipe';
export * from './absorb-by.module';
